import { render } from "./token.vue?vue&type=template&id=3e096192&scoped=true&ts=true"
import script from "./token.vue?vue&type=script&lang=ts"
export * from "./token.vue?vue&type=script&lang=ts"

import "./token.vue?vue&type=style&index=0&id=3e096192&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e096192"]])

export default __exports__